export const formatCashInstanceStatus = (status) => {
	let formattedStatus = "";

    switch(status) {
        case 'pending':
            formattedStatus = "Pendente";
            break;
        case 'completed':
            formattedStatus = "Concluída";
            break;
        case 'confirmed':
            formattedStatus = "Confirmada";
            break;
        case 'canceled':
            formattedStatus = "Cancelada";
            break;
        default:
            formattedStatus = status;
    }

	return formattedStatus;
}


export const formatPaymentStatus = (status) => {
	let formattedStatus = "";

    switch(status) {
        case 'open':
            formattedStatus = "Open";
            break;
        case 'pastDue':
            formattedStatus = "Past Due";
            break;
        case 'completed':
            formattedStatus = "Completed";
            break;
        case 'canceled':
            formattedStatus = "Canceled";
            break;
        case 'paid':
            formattedStatus = "Paid";
            break;
        default:
            formattedStatus = status;
    }

	return formattedStatus;
}

export const formatLetterStatus = (status) => {
	let formattedStatus = "";

    switch(status) {
        case 'open':
            formattedStatus = "Open";
            break;
        case 'late':
            formattedStatus = "Late";
            break;
        case 'sent':
            formattedStatus = "Sent";
            break;
        case 'canceled':
            formattedStatus = "Canceled";
            break;
        case 'paid':
            formattedStatus = "Paid";
            break;
        default:
            formattedStatus = status;
    }

	return formattedStatus;
}

export const formatUnitStatus = (status) => {
    let formattedStatus = "";

    switch(status) {
        case 'unavailable':
            formattedStatus = "Unavailable";
            break;
        case 'available':
            formattedStatus = "Available";
            break;
        case 'sold':
            formattedStatus = "Sold";
            break;
        case 'reserved':
            formattedStatus = "Reserved";
            break;
        default:
            formattedStatus = status;
    }

    return formattedStatus;
}

export const formatUnitOrietation = (status) => {
    let formattedOrietation = "";

    switch(status) {
        case 'left':
            formattedOrietation = "Left";
            break;
        case 'right':
            formattedOrietation = "Right";
            break;
        default:
            formattedOrietation = status;
    }

    return formattedOrietation;
}

export const formatClientActionsStatus = (status) => {
    let formattedStatus = "";

    switch(status) {
        case 'open':
            formattedStatus = "Open";
            break;
        case 'completed':
            formattedStatus = "Completed";
            break;
        default:
            formattedStatus = status;
    }

    return formattedStatus;
}

export const formatClientStatus = (status) => {
    let formattedStatus = "";

    switch(status) {
        case 'available':
            formattedStatus = "Available";
            break;
        case 'reserved':
            formattedStatus = "Reserved";
            break;
        case 'active':
            formattedStatus = "Active";
            break;
        case 'fullyPaid':
            formattedStatus = "Fully Paid";
            break;
        case 'completed':
            formattedStatus = "Completed";
            break;
        case 'canceled':
            formattedStatus = "Canceled";
            break;
        default:
            formattedStatus = status;
    }

    return formattedStatus;
}